
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Coins, MapPin, Phone, Truck, Star, Mountain } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const AchatMetauxLot = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Achat Métaux Lot (46) - Rachat Fer Cuivre Cahors Figeac | Groupe Fabre"
        description="Rachat de métaux dans le Lot : fer, cuivre, aluminium. Service Cahors, Figeac, Gourdon. Pesée certifiée et paiement immédiat."
        canonical="/nos-services/achat-metaux/lot"
        keywords="achat métaux Lot, rachat cuivre Cahors, ferraille 46, métaux Figeac Gourdon"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-green-700 to-green-800 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <div className="flex items-center mb-4">
                <Mountain className="h-12 w-12 mr-4" />
                <div>
                  <h1 className="text-4xl md:text-5xl font-bold">Achat Métaux Lot</h1>
                  <p className="text-xl mt-2 opacity-90">Rachat de métaux dans les sites protégés du 46</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl font-bold text-fabre-gray mb-6">
                  Rachat de métaux dans le Lot (46)
                </h2>
                <p className="text-gray-600 mb-6">
                  <strong>Groupe Fabre Environnement</strong> propose ses services d'achat de métaux 
                  dans tout le <strong>Lot</strong>, en respectant les contraintes des sites protégés. 
                  Nous intervenons à Cahors, Figeac, Gourdon et dans toutes les communes du département 46.
                </p>
                
                <h3 className="text-xl font-bold text-fabre-gray mb-4">Zones d'intervention Lot</h3>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-green-700 mr-3 mt-1" />
                    <span><strong>Cahors :</strong> préfecture et vallée du Lot</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-green-700 mr-3 mt-1" />
                    <span><strong>Figeac :</strong> cité médiévale et industrie</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-green-700 mr-3 mt-1" />
                    <span><strong>Gourdon :</strong> bourret et causses</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-green-700 mr-3 mt-1" />
                    <span><strong>Saint-Céré :</strong> vallée de la Dordogne</span>
                  </li>
                </ul>

                <div className="bg-green-50 border border-green-200 p-6 rounded-lg">
                  <h4 className="font-bold text-green-800 mb-3">Respect environnemental</h4>
                  <ul className="text-green-700 text-sm space-y-2">
                    <li>• Intervention respectueuse des sites classés</li>
                    <li>• Gestion écologique des déchets métalliques</li>
                    <li>• Préservation du patrimoine naturel</li>
                    <li>• Solutions adaptées aux contraintes rurales</li>
                  </ul>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-fabre-gray mb-6">Service écologique</h3>
                <p className="text-gray-600 mb-6">
                  Notre approche respectueuse de l'environnement lotois nous permet 
                  de valoriser vos métaux tout en préservant les sites naturels.
                </p>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <Mountain className="h-5 w-5 text-green-700 mr-3" />
                    <span>Respect sites protégés</span>
                  </div>
                  <div className="flex items-center">
                    <Coins className="h-5 w-5 text-green-700 mr-3" />
                    <span>Prix équitables</span>
                  </div>
                  <div className="flex items-center">
                    <Truck className="h-5 w-5 text-green-700 mr-3" />
                    <span>Transport écologique</span>
                  </div>
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-green-700 mr-3" />
                    <span>Conseil spécialisé</span>
                  </div>
                </div>

                <Link to="/contact" className="block">
                  <button className="w-full px-6 py-3 bg-green-700 text-white rounded-md font-medium hover:bg-green-800 transition-colors">
                    Demander un devis Lot
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AchatMetauxLot;
